import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'awair-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

  @HostBinding('class.--show') hostShow: boolean = false;
  @HostBinding('style.background-color') hostBackgroundColor: string = 'rgba(134, 141, 148, 0.8)';
  @HostBinding('style.border') hostBorder: string = 'none';
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  get type(): ToastType {
    if (this._type != null) {
      return this._type;
    }
  }

  @Input()
  set type(value: ToastType) {
    if (value != null) {
      this._type = value;

      if (value === ToastType.Success) {
        this.hostBackgroundColor = 'rgba(79, 204, 83, 0.8)';
      } else if (value === ToastType.Alert) {
        this.hostBackgroundColor = 'rgba(230, 55, 64, 0.8)';
      } else {
        this.hostBackgroundColor = 'rgba(134, 141, 148, 0.8)';
      }
    }
  }

  private _type: ToastType = ToastType.Information;

  ToastType = ToastType;
  timer;

  constructor() {
  }

  ngOnInit() {
  }

  onClose(): void {
    this.hostShow = false;

    this.hostBorder = 'none';
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.close.emit();
  }

  show(): void {
    this.hostShow = true;

    this.hostBorder = `1px solid ${this.type === ToastType.Success ? '#4FCC53' :
      this.type === ToastType.Alert ? '#E63740' : '#ACB4BB'}`;

    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.onClose();
    }, 3000);
  }
}

export enum ToastType {
  Information = 'information',
  Success = 'success',
  Alert = 'alert'
}
